module.exports = {
      id: "breaking-news-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#breaking-news",
      toString: function () {
        return this.url;
      }
    }